import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const FormTextarea = styled.textarea<{ darkBorder?: boolean }>`
    width: 100%;
    border: 1px solid ${({ theme }) => theme.greys[50]};
    border-radius: ${({ theme }) => theme.borderRadius.small}px;
    padding: 1rem 16px;
    font-size: 1rem;
    min-height: 3.5rem;
    line-height: 1.5rem;
    resize: vertical;

    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.greys[50]};
    }

    &:hover {
        border-color: ${({ theme }) => theme.greys[100]};
    }

    ::placeholder {
        color: ${({ theme }) => theme.colors.primary};
    }

    ${({ darkBorder, theme }) =>
        darkBorder &&
        css`
            border: 1px solid ${theme.greys[100]};

            &:hover {
                border-color: ${theme.greys[300]};
            }
        `}
`;
